import { create } from 'zustand'
import { combine, persist } from 'zustand/middleware'

import { clearAuthStoreAction, setAuthTokenAction, setUserActivePermissionGroupAction } from './auth.actions'

import type { PermissionsGroupsEnumType } from '@/features/auth/types'
import subscribeToStore from '@/lib/zustand'

export type AuthStoreValuesType = {
  authToken: string | null
  userActivePermissionGroup: PermissionsGroupsEnumType | null
  userLanguage: string | null
}

export const INITIAL_AUTH_STORE_VALUES: AuthStoreValuesType = {
  authToken: null,
  userActivePermissionGroup: null,
  userLanguage: null,
}

export const AUTH_STORAGE_KEY = 'auth'

const authStore = subscribeToStore(
  create(
    persist(
      combine(INITIAL_AUTH_STORE_VALUES, (set, get) => ({
        setAuthToken: async (authToken: string) => setAuthTokenAction(get, set, authToken),
        setUserActivePermissionGroup: (userActivePermissionGroup: PermissionsGroupsEnumType | null) =>
          setUserActivePermissionGroupAction(get, set, userActivePermissionGroup),
        setUserLanguage: (userLanguage: string) => set({ userLanguage }),
        clearAuthStore: async () => clearAuthStoreAction(get, set),
      })),
      {
        name: AUTH_STORAGE_KEY,
      },
    ),
  ),
)

export default authStore
